import {environment} from '@env/environment';


export const PAYMENT_CODE = {
    OMISE: 'EWL001',
    MPAY: 'EWL003',
    LINEPAY: 'EWL002',
    KBANK: 'BSV001',
    BANK: 'BSV001',
    TPC: 'BSV001',
    CASH: 'CSH001',
    DISCOUNT: 'CSH001'
};

export const APP = {
    uploadURL: environment.api3Url + '/api/internal/file-catalog/upload'
};

